import { render, staticRenderFns } from "./PackingPositionMonitor.vue?vue&type=template&id=0072f032"
import script from "./PackingPositionMonitor.vue?vue&type=script&lang=js"
export * from "./PackingPositionMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports